import React from 'react'
import { BreadCrumbContainer, BreadCrumbTrigger } from './styles'

interface BreadCrumbProps {
  children: string
  handleClick: VoidFunction
  isLastCrumb: boolean
}

export const BreadCrumb = ({ children, handleClick, isLastCrumb }: BreadCrumbProps): JSX.Element => {
  return (
    <BreadCrumbContainer>
      <BreadCrumbTrigger isLastCrumb={isLastCrumb} onClick={handleClick}>
        {children}
      </BreadCrumbTrigger>
    </BreadCrumbContainer>
  )
}
